import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { RoleService } from '@services/roles/role.service';
import { FormComponent } from '../../../components/default-form/form.component';

@Component({
    selector: 'app-role-edit',
    templateUrl: './role-edit.component.html',
    styleUrls: ['./role-edit.component.scss'],
    providers: [RoleService],
    standalone: false
})
export class RoleEditComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  pageActions: PageAction[] = [];
  title = 'Create Role';
  isLoading = true;
  boundRole: Models.Role;
  roleId: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private roleService: RoleService,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params['id']) {
      this.roleId = this.activatedRoute.snapshot.params['id'];
      this.title = 'Edit Role';
      this.roleService.get(this.roleId).then(result => {
        this.boundRole = result;
        this.isLoading = false;
        this.loadForm();
      });
    } else {
      this.boundRole = <Models.Role>Models.ModelFactory.createModelInstanceByName('Role');
      this.isLoading = false;
      this.loadForm();
    }
    this.createPageActions();
  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundRole;
  }

  onSave() {
    return this.boundRole.validate(true).then(result => {
      if (result.success) {
        if (this.roleId) {
          this.roleService.update(this.roleId, this.boundRole).then(organisationResult => {
            console.log(organisationResult);
          });
        } else {
          this.roleService.create(this.boundRole).then(organisationResult => {
            console.log(organisationResult);
            this.roleId = organisationResult.RoleID.toString();
            this.createPageActions();
          });
        }
      } else {
        this.snackbar.open('Could not create the organisation, please fill the form correctly');
      }
    });
  }

  createPageActions() {
    if (this.roleId) {
      this.pageActions.push(new PageAction({
        icon: 'info',
        title: 'Detail Role',
        callback: () => {
          this.router.navigate(['roles', this.roleId]);
        }
      }));
    }
  }
}
